import {Navigate, useOutlet} from "react-router-dom";
import {getToken, removeTokens} from "../Main/AuthToken";
import {useEffect} from "react";
import {useSnackbar} from "notistack";
import {removeCondoId, removeCondoName, removeFilterDate, removeLocalUnitUser, removeLocalUser} from "../Main/AuthStorage";
import {getUserToken, getUserRefreshToken, removeTokensUnitUser} from "./UnitUserToken";
import jwt_decode from "jwt-decode";


const RequiredUnitAuth = () => {
  const outlet = useOutlet()
  const { enqueueSnackbar } = useSnackbar()

  useEffect(function withoutCookies(){
    if (!getUserToken()){
      enqueueSnackbar('Por favor realize login', {
        anchorOrigin: {
          vertical: 'bottom',
          horizontal: 'center'
        }
      })
      removeTokensUnitUser()
      removeLocalUnitUser()
      removeCondoId()
      removeCondoName()
      removeFilterDate()
    }

  },[])

  const token = getUserToken()

  if (!token) {
    return <Navigate to={'/login/usuario'} replace={true} />
  }

  // Only redirect to login if the refresh token is also expired
  const refreshToken = getUserRefreshToken()
  if (refreshToken) {
    try {
      const decodedRefresh = jwt_decode(refreshToken)
      if (decodedRefresh.exp && decodedRefresh.exp * 1000 < Date.now()) {
        removeTokensUnitUser()
        removeLocalUnitUser()
        removeCondoId()
        removeCondoName()
        removeFilterDate()
        return <Navigate to={'/login/usuario'} replace={true} />
      }
    } catch (e) {
      removeTokensUnitUser()
      removeLocalUnitUser()
      removeCondoId()
      removeCondoName()
      removeFilterDate()
      return <Navigate to={'/login/usuario'} replace={true} />
    }
  }

  return outlet
}

export default RequiredUnitAuth;
